import dayjs from 'dayjs';
import pdfMake from "pdfmake/build/pdfmake";
import vfsFonts from "pdfmake/build/vfs_fonts";   // ไฟล์ที่ generate ไว้เอง
import { formatCurrency, numberToThaiText } from '../utils/helpers';
import { loadImageBase64 } from "../utils/loadImageBase64";
import { Radius } from 'lucide-react';


// ตั้งค่าให้ pdfMake ใช้ฟอนต์จาก vfs_fonts
pdfMake.vfs = vfsFonts;
//pdfMake.addVirtualFileSystem(vfsFonts);


pdfMake.fonts = {
    THSarabunNew: {
        normal: 'THSarabunNew.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf'
    }
};

// กำหนด font สำหรับ pdfMake
const initializePdfMake = () => {
    if (window.pdfMake) {
        // กำหนด font เป็น default fonts ของ pdfMake
        window.pdfMake.fonts = {
            THSarabunNew: {
                normal: 'THSarabunNew.ttf',
                bold: 'THSarabunNew Bold.ttf',
                italics: 'THSarabunNew Italic.ttf',
                bolditalics: 'THSarabunNew BoldItalic.ttf'
            }
        };
    }
};



//ใช้ฟังชั่นนี้เป็นส่วนใหญ่
export const generateQuotePDF = async (quote, company = {}, vatMode, calcValues) => {

    //กรณีใช้ local logo:   process.env.PUBLIC_URL + "/assets/ttlogo.png"
    const logoBase64 = await loadImageBase64(`${process.env.REACT_APP_API_URL}/uploads/${company?.logo_path}`);
    console.log('ข้อมูลใบเสนอราคา', quote);

    // ตรวจสอบว่า pdfMake โหลดแล้วหรือยัง
    if (!window.pdfMake) {
        throw new Error('pdfMake library is not loaded');
    }

    // กำหนด font
    initializePdfMake();

    const totalAmount = quote.items?.reduce((sum, item) => {
        return sum + (item.quantity * item.unitPrice);
    }, 0) || 0;

    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [23, 30, 23, 50], //left, top, right, bottom
        defaultStyle: {
            font: 'THSarabunNew',
            fontSize: 14
        },
        styles: {
            header: {
                fontSize: 20,
                bold: true,
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },
            subheader: {
                fontSize: 16,
                bold: true,
                margin: [0, 10, 0, 5]
            },
            notes: {
                fontSize: 14,
                bold: false,
                margin: [0, 10, 0, 5]
            },
            tableHeader: {
                bold: true,
                fontSize: 16,
                Radius: 10,
                color: 'black',
                fillColor: '#E3F2FD' // 💙 สีฟ้าอ่อน
            },
            bathText: {
                fontSize: 15,
                bold: true,
                alignment: 'left'
            },
            total: {
                fontSize: 16,
                bold: true,
                alignment: 'right'
            }
        },
        content: [
            // หัวข้อ
            {
                text: 'ใบเสนอราคา (QUOTATION)',
                bold: true, fontSize: 25,
                alignment: 'right',
                color: '#054eed' // 💙 สีฟ้าอ่อน
            },

            // =============================
            // ส่วนข้อมูลบริษัท (มีพื้นหลังฟ้าอ่อน)
            // =============================
            {
                table: {
                    widths: ['60%', '40%'],
                    body: [
                        [
                            {
                                columns: [
                                    {
                                        ...(logoBase64
                                            ? { image: logoBase64, width: 80, alignment: 'left', margin: [0, 18, 0, 0] }
                                            : { text: '', fontSize: 18, bold: true, margin: [0, 18, 0, 0] }
                                        ),
                                    },
                                    {
                                        lineHeight: 0.8,
                                        stack: [
                                            { text: company.company_name || 'ชื่อบริษัท', bold: true, fontSize: 16 },
                                            { text: company.address || 'ที่อยู่บริษัท', margin: [0, 0, 0, 0] },
                                            { text: `โทรศัพท์: ${company.phone || 'หมายเลขโทรศัพท์'}`, margin: [0, 0, 0, 0] },
                                            { text: company.tax_id ? `เลขที่ภาษี: ${company.tax_id} ${company.branch_name === '-' ? '' : '(' + company.branch_name + ')'}` : '', margin: [0, 0, 0, 0] }
                                        ],
                                        margin: [10, 18, 0, 10]
                                    },
                                ],
                                border: [false, false, false, false],
                                margin: [0, -65, 0, 10]
                            },
                            {
                                stack: [
                                    {
                                        canvas: [
                                            {
                                                type: 'rect',
                                                x: 0,
                                                y: 0,
                                                w: 160, // กำหนดความกว้างของพื้นหลัง (ปรับได้)
                                                h: 50,  // กำหนดความสูงของพื้นหลัง (พอดีข้อความ)
                                                r: 10,  // ความมนของขอบ 10px
                                                color: '#E3F2FD' // 💙 สีฟ้าอ่อน
                                            }
                                        ],
                                        absolutePosition: { x: 350, y: 85 }, // ปรับตำแหน่งตาม layout ของคุณ
                                    },
                                    {
                                        text: [
                                            { text: 'เลขที่เอกสาร: ', bold: true },
                                            { text: quote.quoteNumber || '-', bold: false },

                                        ],
                                        margin: [0, 0, 20, 0],
                                    },
                                    {
                                        text: [
                                            { text: 'วันที่: ', bold: true },
                                            { text: dayjs(quote.quoteDate).format('DD/MM/YYYY'), bold: false }
                                        ],
                                        margin: [0, 0, 20, 0],
                                    },
                                    // ถ้าต้องการเพิ่มวันหมดอายุ uncomment ตรงนี้
                                    // {
                                    //   text: [
                                    //     { text: 'วันหมดอายุ: ', bold: true },
                                    //     { text: dayjs(quote.validUntil).format('DD/MM/YYYY'), bold: false }
                                    //   ],
                                    //   margin: [0, 2, 0, 0]
                                    // }
                                ],
                                alignment: 'right',
                                border: [false, false, false, false],
                                margin: [0, 25, 0, 0]
                            }
                        ]
                    ]
                },
                margin: [0, 0, 0, 0]
            },

            // ข้อมูลลูกค้า
            {
                lineHeight: 0.8,
                text: [
                    { text: `เรียน ${quote.customer?.name || '-'}`, bold: false },
                    '\n',
                    { text: `${quote.customer?.company || '-'}`, bold: false },
                    '\n',
                    { text: 'ที่อยู่: ', bold: false },
                    quote.data?.address || '-',
                    '\n',
                    { text: 'โทรศัพท์: ', bold: false },
                    quote.customer?.phone || '-',
                    '\n',
                    { text: 'เลขที่ภาษี: ', bold: false },
                    quote.customer?.tax_id || '-'
                ],
                margin: [10, -25, 0, 10]
            },

            // รายการสินค้า/บริการ
            {
                text: 'บริษัทฯ มีความยินดีจะเสนอราคาสินค้า ดังต่อไปนี้',
                fontSize: 14,
                margin: [50, 0, 0, 20]
            },
            {
                table: {
                    headerRows: 0,
                    widths: [26, 69, 232, 52, 55, 65],
                    body: [
                        [
                            { text: 'ที่', style: 'tableHeader', alignment: 'center' },
                            { text: 'รหัสสินค้า', style: 'tableHeader', alignment: 'center' },
                            { text: 'รายการ', style: 'tableHeader', alignment: 'center' },
                            { text: 'จำนวน', style: 'tableHeader', alignment: 'center' },
                            { text: 'หน่วยละ', style: 'tableHeader', alignment: 'center' },
                            { text: 'รวม', style: 'tableHeader', alignment: 'center' }
                        ],
                        ...(quote.items || []).map((item, index) => [
                            { text: (index + 1).toString(), alignment: 'center' }, // ✅ ลำดับที่
                            { text: item.barcode || '-', alignment: 'center' }, //บาร์โค้ด
                            { text: `${item.description ? `${item.name}\n${item.description}` : item.name}` || '-', alignment: 'left' }, //รายละเอียดสินค้า
                            { text: `${item.quantity?.toString()} ${item.unit?.toString() || 0}`, alignment: 'left' }, //จำนวน

                            // ✅ ถ้าเป็นของแถม (is_free = 1) ให้ซ่อนราคา / แสดงเป็นช่องว่างหรือเครื่องหมาย “–”
                            {
                                text: item.is_free === true || item.is_free === 1 ? '' : `${(formatCurrency(item.unitPrice) || 0).toLocaleString()}`, //ราคา/หน่วย
                                alignment: 'right'
                            },
                            {
                                text: item.is_free === true || item.is_free === 1 ? '' : `${(formatCurrency((item.quantity || 0) * (item.unitPrice || 0))).toLocaleString()}`, //ราคารวม
                                alignment: 'right'
                            }

                        ])
                    ]
                },
                // layout: {
                //     fillColor: function (rowIndex, node, columnIndex) {
                //         return (rowIndex === 0) ? '#eeeeee' : null;
                //     }
                // },
                layout: 'noBorders',
                margin: [0, 0, 0, 20]
            },

            //ส่วนท้ายของหน้ากระดาษ จะแสดงเฉพาะหน้าสุดท้ายเเท่านั้น

        ],

        footer: function (currentPage, pageCount) {
            if (currentPage !== pageCount) return {}; // แสดงเฉพาะหน้าสุดท้าย

            return {
                margin: [40, -200, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
                lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                stack: [
                    // ==== 🎨 พื้นหลัง GRAND TOTAL เฉพาะแถวสุดท้าย ====
                    {
                        canvas: [
                            {
                                type: 'rect',
                                x: 0,
                                y: 0,
                                w: 225,   // ✅ ความกว้างพื้นหลัง
                                h: 28,    // ✅ ความสูงหนึ่งแถว
                                r: 5,    // ✅ ขอบมน 10px
                                color: '#E3F2FD'
                            }
                        ],
                        // ✅ ต้องปรับตำแหน่งให้เข้ากับเอกสารของคุณ
                        // ค่านี้เบื้องต้น หากสูงเกิน/ต่ำไป แจ้งผมได้
                        absolutePosition: { x: 330, y: -116 }
                    },
                    {
                        columns: [
                            {
                                lineHeight: 0.9,   // <— ค่านี้ยิ่งน้อย บรรทัดจะยิ่งชิดกัน
                                width: '55%',
                                style: 'bathText',
                                stack: [
                                    // เงื่อนไข
                                    {
                                        text: 'ข้อกำหนด และเงื่อนไขการขอใบเสนอราคา',
                                        style: 'subheader',
                                        margin: [0, 10, 0, 0]
                                    },
                                    {
                                        text: quote.data.notes?quote.data.notes:`- กำหนดยืนราคา ภายใน 30 วัน นับจากวันที่เสนอราคา \n - กำหนดส่งของ ภายใน 30 วัน นับจากวันที่ได้รับใบสั่งซื้อ`,
                                        margin: [15, 0, 0, 21], fontSize: 13

                                    },
                                    {
                                        text: `${numberToThaiText(quote.data.total_amount)}`,
                                        margin: [0, -3, 0, 0], fontSize: 18
                                    }
                                ],
                                margin: [5, 0, 40, 0], // <— ดึงขึ้น (negative top margin สำคัญ)
                            },
                            {
                                width: '53%',
                                table: {
                                    body: [
                                        // สำหรับ VAT INCLUDE - ใช้โครงสร้างเดิมแต่เปลี่ยนข้อความอธิบาย
                                        [
                                            { text: 'รวมจำนวนเงิน (TOTAL AMOUNT):', alignment: 'right', fontSize: 15 },
                                            { text: `${(formatCurrency(quote.data.total_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                                        ],
                                        [
                                            { text: 'ส่วนลด (DISCOUNT):', alignment: 'right', fontSize: 15 },
                                            { text: `${(formatCurrency(quote.data.discount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                                        ],
                                        [
                                            { text: 'ราคาสินค้าไม่รวมภาษี (SUB TOTAL):', alignment: 'right', fontSize: 15 },
                                            { text: `${(formatCurrency(quote.data.subtotal) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                                        ],
                                        [
                                            { text: `ภาษีมูลค่าเพิ่ม (VAT):`, alignment: 'right', fontSize: 15 },
                                            { text: `${(formatCurrency(quote.data.tax_amount) || 0).toLocaleString()} บาท`, alignment: 'right', fontSize: 15 }
                                        ],
                                        [
                                            { text: 'รวมทั้งสิ้น (GRAND TOTAL):', bold: true, alignment: 'right', fontSize: 16 },
                                            { text: `${formatCurrency(quote.data.total_amount).toLocaleString()} บาท`, bold: true, alignment: 'right', fontSize: 16 }
                                        ],
                                    ]
                                },
                                layout: 'noBorders'
                            }
                        ],
                        margin: [0, 0, 0, 20]
                    },

                    // ลายเซ็น
                    {
                        columns: [
                            {
                                width: '50%',
                                alignment: 'center',
                                text: [
                                    'กรุณาเซ็นยืนยันการสั่งซื้อด้านล่าง',
                                    '\n\n',
                                    '(............................................)',
                                    '\n',
                                    'ผู้สั่งซื้อสินค้า'
                                ],
                                fontSize: 16
                            },
                            {
                                width: '50%',
                                alignment: 'center',
                                text: [
                                    'ขอแสดงความนับถือ',
                                    '\n\n',
                                    '(............................................)',
                                    '\n',
                                    'ผู้จัดการฝ่ายขาย'
                                ],
                                fontSize: 16
                            }
                        ]
                    }
                ]
            };
        }

    };

    try {

        // สร้าง PDF
        const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);

        return new Promise((resolve, reject) => {
            pdfDocGenerator.getDataUrl((dataUrl) => {
                if (dataUrl) resolve(dataUrl);
                else reject(new Error('ไม่สามารถสร้าง PDF preview ได้'));
            });
        });

        //return { success: true, fileName };
    } catch (error) {
        console.error('Error generating PDF:', error);
        throw new Error('ไม่สามารถสร้าง PDF ได้: ' + error.message);
    }
};

// ฟังก์ชันสำหรับดู PDF ในหน้าต่างใหม่
export const previewQuotePDF = async (quote, company = {}) => {
    if (!window.pdfMake) {
        throw new Error('pdfMake library is not loaded');
    }

    initializePdfMake();

    // สร้าง docDefinition ใหม่สำหรับการดูตัวอย่าง
    const totalAmount = quote.items?.reduce((sum, item) => {
        return sum + (item.quantity * item.unitPrice);
    }, 0) || 0;

    const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 60, 40, 60],
        defaultStyle: {
            font: 'THSarabunNew'
        },
        styles: {
            header: {
                fontSize: 16,
                bold: false,
                alignment: 'center',
                margin: [0, 0, 0, 20]
            },
            subheader: {
                fontSize: 12,
                bold: false,
                margin: [0, 10, 0, 5]
            },
            tableHeader: {
                bold: false,
                fontSize: 10,
                color: 'black',
                fillColor: '#eeeeee'
            },
            total: {
                fontSize: 12,
                bold: false,
                alignment: 'right'
            }
        },
        content: [
            // หัวข้อ
            {
                text: 'ใบเสนอราคา (QUOTATION)',
                style: 'header'
            },

            // ข้อมูลบริษัท
            {
                columns: [
                    {
                        width: '50%',
                        text: [
                            { text: 'บริษัท: ', bold: false },
                            company.name || 'ชื่อบริษัท',
                            '\n',
                            { text: 'ที่อยู่: ', bold: false },
                            company.address || 'ที่อยู่บริษัท',
                            '\n',
                            { text: 'โทรศัพท์: ', bold: false },
                            company.phone || 'หมายเลขโทรศัพท์'
                        ]
                    },
                    {
                        width: '50%',
                        text: [
                            { text: 'เลขที่เอกสาร: ', bold: false },
                            quote.quoteNumber || '-',
                            '\n',
                            { text: 'วันที่: ', bold: false },
                            dayjs(quote.quoteDate).format('DD/MM/YYYY'),
                            '\n',
                            { text: 'วันหมดอายุ: ', bold: false },
                            dayjs(quote.validUntil).format('DD/MM/YYYY')
                        ],
                        alignment: 'right'
                    }
                ],
                margin: [0, 0, 0, 20]
            },

            // ข้อมูลลูกค้า
            {
                text: 'ข้อมูลลูกค้า',
                style: 'subheader'
            },
            {
                text: [
                    { text: 'ชื่อลูกค้า: ', bold: false },
                    quote.customer?.name || '-',
                    '\n',
                    { text: 'บริษัท: ', bold: false },
                    quote.customer?.company || '-',
                    '\n',
                    { text: 'ที่อยู่: ', bold: false },
                    quote.customer?.address || '-',
                    '\n',
                    { text: 'โทรศัพท์: ', bold: false },
                    quote.customer?.phone || '-',
                    '\n',
                    { text: 'อีเมล: ', bold: false },
                    quote.customer?.email || '-'
                ],
                margin: [0, 0, 0, 20]
            },

            // รายการสินค้า/บริการ
            {
                text: 'รายการสินค้า/บริการ',
                style: 'subheader'
            },
            {
                table: {
                    headerRows: 1,
                    widths: ['*', 'auto', 'auto', 'auto'],
                    body: [
                        [
                            { text: 'รายการ', style: 'tableHeader' },
                            { text: 'จำนวน', style: 'tableHeader', alignment: 'center' },
                            { text: 'ราคาต่อหน่วย', style: 'tableHeader', alignment: 'right' },
                            { text: 'รวม', style: 'tableHeader', alignment: 'right' }
                        ],
                        ...(quote.items || []).map(item => [
                            { text: item.description || '-' },
                            { text: item.quantity?.toString() || '0', alignment: 'center' },
                            { text: `${(item.unitPrice || 0).toLocaleString()} บาท`, alignment: 'right' },
                            { text: `${((item.quantity || 0) * (item.unitPrice || 0)).toLocaleString()} บาท`, alignment: 'right' }
                        ])
                    ]
                },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        return (rowIndex === 0) ? '#eeeeee' : null;
                    }
                },
                margin: [0, 0, 0, 20]
            },

            // ยอดรวม
            {
                columns: [
                    { width: '70%', text: '' },
                    {
                        width: '30%',
                        table: {
                            body: [
                                [
                                    { text: 'ยอดรวมทั้งสิ้น:', bold: false },
                                    { text: `${totalAmount.toLocaleString()} บาท`, style: 'total' }
                                ]
                            ]
                        },
                        layout: 'noBorders'
                    }
                ]
            },

            // หมายเหตุ
            quote.notes ? {
                text: 'หมายเหตุ',
                style: 'subheader',
                margin: [0, 20, 0, 5]
            } : {},
            quote.notes ? {
                text: quote.notes,
                margin: [0, 0, 0, 20]
            } : {},

            // เงื่อนไข
            {
                text: 'ข้อกำหนด และเงื่อนไขการขอใบเสนอราคา',
                style: 'subheader',
                margin: [0, 20, 0, 5]
            },
            {
                text: quote.paymentTerms || 'กำหนดยืนราคา ภายใน 60 วัน นับจากวันที่เสนอราคา',
                margin: [0, 0, 0, 30]
            },
            {
                text: quote.paymentTerms || 'กำหนดส่งของ ภายใน 30 วัน นับจากวันที่ได้รับใบสั่งซื้อ',
                margin: [0, 0, 0, 30]
            },

            // ลายเซ็น
            {
                columns: [
                    {
                        width: '50%',
                        text: 'กรุณาเซ็นต์ยืนยันการสั่งซื้อด้านล่าง',
                        alignment: 'center'
                    },
                    {
                        width: '50%',
                        text: [
                            'ลงชื่อ ......................................',
                            '\n\n',
                            '(                                            )',
                            '\n',
                            'ผู้สั่งซื้อสินค้า'
                        ],
                        alignment: 'center'
                    },
                    {
                        width: '50%',
                        text: 'ขอแสดงความนับถือ',
                        alignment: 'center'
                    }
                    ,
                    {
                        width: '50%',
                        text: [
                            'ลงชื่อ ......................................',
                            '\n\n',
                            '(                                            )',
                            '\n',
                            'ผู้เตรียมเอกสาร'
                        ],
                        alignment: 'center'
                    }
                ]
            }
        ]
    };



    const generateDocDefinition = (quote, company = {}) => {
        const totalAmount = quote.items?.reduce((sum, item) => {
            return sum + (item.quantity * item.unitPrice);
        }, 0) || 0;

        return {
            pageSize: 'A4',
            pageMargins: [40, 60, 40, 60],
            defaultStyle: {
                font: 'THSarabunNew'
            },
            styles: {
                header: {
                    fontSize: 16,
                    bold: false,
                    alignment: 'center',
                    margin: [0, 0, 0, 20]
                },
                subheader: {
                    fontSize: 12,
                    bold: false,
                    margin: [0, 10, 0, 5]
                },
                tableHeader: {
                    bold: false,
                    fontSize: 10,
                    color: 'black',
                    fillColor: '#eeeeee'
                },
                total: {
                    fontSize: 12,
                    bold: false,
                    alignment: 'right'
                }
            },
            content: [
                // หัวข้อ
                { text: 'ใบเสนอราคา (QUOTATION)', style: 'header' },

                // ข้อมูลบริษัท
                {
                    columns: [
                        {
                            width: '50%',
                            text: [
                                { text: 'บริษัท: ', bold: false },
                                company.name || 'ชื่อบริษัท',
                                '\n',
                                { text: 'ที่อยู่: ', bold: false },
                                company.address || 'ที่อยู่บริษัท',
                                '\n',
                                { text: 'โทรศัพท์: ', bold: false },
                                company.phone || 'หมายเลขโทรศัพท์'
                            ]
                        },
                        {
                            width: '50%',
                            text: [
                                { text: 'เลขที่เอกสาร: ', bold: false },
                                quote.quoteNumber || '-',
                                '\n',
                                { text: 'วันที่: ', bold: false },
                                dayjs(quote.quoteDate).format('DD/MM/YYYY'),
                                '\n',
                                { text: 'วันหมดอายุ: ', bold: false },
                                dayjs(quote.validUntil).format('DD/MM/YYYY')
                            ],
                            alignment: 'right'
                        }
                    ],
                    margin: [0, 0, 0, 20]
                },

                // ข้อมูลลูกค้า
                { text: 'ข้อมูลลูกค้า', style: 'subheader' },
                {
                    text: [
                        { text: 'ชื่อลูกค้า: ', bold: false },
                        quote.customer?.name || '-',
                        '\n',
                        { text: 'บริษัท: ', bold: false },
                        quote.customer?.company || '-',
                        '\n',
                        { text: 'ที่อยู่: ', bold: false },
                        quote.customer?.address || '-',
                        '\n',
                        { text: 'โทรศัพท์: ', bold: false },
                        quote.customer?.phone || '-',
                        '\n',
                        { text: 'อีเมล: ', bold: false },
                        quote.customer?.email || '-'
                    ],
                    margin: [0, 0, 0, 20]
                },

                // รายการสินค้า/บริการ
                { text: 'รายการสินค้า/บริการ', style: 'subheader' },
                {
                    table: {
                        headerRows: 1,
                        widths: ['*', 'auto', 'auto', 'auto'],
                        body: [
                            [
                                { text: 'รายการ', style: 'tableHeader' },
                                { text: 'จำนวน', style: 'tableHeader', alignment: 'center' },
                                { text: 'ราคาต่อหน่วย', style: 'tableHeader', alignment: 'right' },
                                { text: 'รวม', style: 'tableHeader', alignment: 'right' }
                            ],
                            ...(quote.items || []).map(item => [
                                { text: item.description || '-' },
                                { text: item.quantity?.toString() || '0', alignment: 'center' },
                                { text: `${(item.unitPrice || 0).toLocaleString()} บาท`, alignment: 'right' },
                                { text: `${((item.quantity || 0) * (item.unitPrice || 0)).toLocaleString()} บาท`, alignment: 'right' }
                            ])
                        ]
                    },
                    layout: {
                        fillColor: (rowIndex) => (rowIndex === 0 ? '#eeeeee' : null)
                    },
                    margin: [0, 0, 0, 20]
                },

                // ยอดรวม
                {
                    columns: [
                        { width: '70%', text: '' },
                        {
                            width: '30%',
                            table: {
                                body: [
                                    [
                                        { text: 'ยอดรวมทั้งสิ้น:', bold: false },
                                        { text: `${totalAmount.toLocaleString()} บาท`, style: 'total' }
                                    ]
                                ]
                            },
                            layout: 'noBorders'
                        }
                    ]
                },

                // หมายเหตุ
                ...(quote.notes ? [
                    { text: 'หมายเหตุ', style: 'subheader', margin: [0, 20, 0, 5] },
                    { text: quote.notes, margin: [0, 0, 0, 20] }
                ] : []),

                // เงื่อนไข
                {
                    text: 'ข้อกำหนด และเงื่อนไขการขอใบเสนอราคา',
                    style: 'subheader',
                    margin: [0, 20, 0, 5]
                },
                {
                    text: quote.paymentTerms || 'กำหนดยืนราคา ภายใน 60 วัน นับจากวันที่เสนอราคา',
                    margin: [0, 0, 0, 30]
                },
                {
                    text: quote.paymentTerms || 'กำหนดส่งของ ภายใน 30 วัน นับจากวันที่ได้รับใบสั่งซื้อ',
                    margin: [0, 0, 0, 30]
                },

                // ลายเซ็น
                {
                    columns: [
                        {
                            width: '50%',
                            text: 'กรุณาเซ็นต์ยืนยันการสั่งซื้อด้านล่าง',
                            alignment: 'center'
                        },
                        {
                            width: '50%',
                            text: [
                                'ลงชื่อ ......................................',
                                '\n\n',
                                '(                                            )',
                                '\n',
                                'ผู้สั่งซื้อสินค้า'
                            ],
                            alignment: 'center'
                        },
                        {
                            width: '50%',
                            text: 'ขอแสดงความนับถือ',
                            alignment: 'center'
                        }
                        ,
                        {
                            width: '50%',
                            text: [
                                'ลงชื่อ ......................................',
                                '\n\n',
                                '(                                            )',
                                '\n',
                                'ผู้เตรียมเอกสาร'
                            ],
                            alignment: 'center'
                        }
                    ]
                }
            ]
        };
    };


    try {
        // const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);
        // pdfDocGenerator.open();
        // return { success: true };

        const docDefinition = generateDocDefinition(quote, company); // สมมติแยกฟังก์ชันสร้าง docDefinition
        const pdfDocGenerator = window.pdfMake.createPdf(docDefinition);

        return new Promise((resolve, reject) => {
            pdfDocGenerator.getDataUrl((dataUrl) => {
                if (dataUrl) resolve(dataUrl);
                else reject(new Error('ไม่สามารถสร้าง PDF preview ได้'));
            });
        });

    } catch (error) {
        console.error('Error previewing PDF:', error);
        throw new Error('ไม่สามารถแสดงตัวอย่าง PDF ได้: ' + error.message);
    }
};
